import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getPagination = (state) => get(state, 'employees.list.pagination', {});
export const getFilters = (state) => get(state, 'employees.list.filters', {});

export const getEmployeesIds = (state) => get(state, 'employees.list.result.employees', []);
export const getEmployees = (state) => get(state, 'employees.list.entities.employees', {});

export const getIsLoading = (state) => get(state, 'employees.list.isLoading', false);
export const getNeedFetch = (state) => get(state, 'employees.list.needFetch', false);

export const getIsFetching = (state) => get(state, 'employees.form.isFetching', false);
export const getIsFetchingConfig = (state) => get(state, 'employees.form.isFetchingConfig', false);
export const getIsSaving = (state) => get(state, 'employees.form.isSaving', false);
export const getEditing = (state) => get(state, 'employees.form.editing', false);

export const getVisibleEmployees = createSelector(
  [getEmployeesIds, getEmployees],
  (ids, employees) => ids.map((id) => employees[id]).filter((employee) => !employee.deleted)
);



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/selectors/employees_selectors.js